import React, { useEffect } from 'react';

interface Space {
  children: string | React.ReactNode;
  marginRight?: number;
  style?: React.CSSProperties;
}

const Space: React.FC<Space> = ({ children, marginRight = 8, style }) => {
  useEffect(() => {
    const container = document.getElementsByClassName('containerSpace');
    for (let i = 0; i < container.length; i++) {
      container[i].style.display = 'flex';
      container[i].style.alignItems = 'center';
      const child = container[i]?.childNodes;
      child?.forEach((items, index) => {
        if (index !== child?.length - 1) {
          items.style.marginRight = `${marginRight}px`;
        }
      });
    }
  }, []);
  return (
    <div className="containerSpace" style={{ ...style }}>
      {children}
    </div>
  );
};
export default Space;
